import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-alerts"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "quantity" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Título do alerta"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Data limite"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo que o documento precisa ser enviado.", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 1)
const _hoisted_13 = { class: "quantity" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Descrição"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "Descreva em uma frase curta as informações desse alerta.", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_17 = { for: "stats" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "modal-date-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Data limite"),
  /*#__PURE__*/_createElementVNode("h2", null, "Prazo máximo para ser aceito.")
], -1)

import AlertModel from '@/models/AlertModel'
import { computed, onMounted, ref } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import { useAxios } from '@/api/axios'
import { toast } from 'vue3-toastify'
import { AxiosResponse } from 'axios'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import AlertStatusEnum from '@/enums/AlertStatusEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditAlertView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const payload = ref<Partial<AlertModel>>({})
const selectedLimitDate = ref('')
const isLimitDateModalOpen = ref(false)
const isUpdatingAlert = ref(false)
const formattedLimitDate = computed(() => payload.value.limit_date ? formatDate(payload.value.limit_date) : undefined)

function updateAlert () {
  isUpdatingAlert.value = true

  axios.put('/api/alerts', {
    title: payload.value.title,
    limit_date: payload.value.limit_date,
    status: payload.value.status ? AlertStatusEnum.ACTIVE : AlertStatusEnum.INACTIVE,
    description: payload.value.description,
    alert_ids: [payload.value.id]
  })
    .then(() => {
      toast.success('Alerta editado com sucesso')
    })
    .finally(() => isUpdatingAlert.value = false)
}

function getAlert () {
  axios.get(`/api/alerts/${props.id}`)
    .then((res: AxiosResponse<AlertModel>) => {
      payload.value = { ...res.data, status: res.data.status == AlertStatusEnum.ACTIVE }
    })
}

const formatDate = (date: string) => {
  const [year, mouth, day] = date.split('-')
  return `${day.split('')[0]}${day.split('')[1]}/${mouth}/${year}`
}

onMounted(() => {
  getAlert()
})

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            maxlength: 100,
            type: "text",
            placeholder: "Ex: Envio de informações de folha",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.title) = $event))
          }, null, 512), [
            [_vModelText, payload.value.title]
          ]),
          (payload.value.title)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(payload.value.title.length) + "/100", 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, "0/100"))
        ]),
        _createElementVNode("section", null, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("label", {
            class: "date-picker-label",
            for: "limit_date",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (isLimitDateModalOpen.value = true))
          }, [
            _createElementVNode("input", {
              type: "text",
              placeholder: "Selecione uma data",
              name: "limit_date",
              value: formattedLimitDate.value ? formattedLimitDate.value : '',
              id: "limit_date",
              readonly: ""
            }, null, 8, _hoisted_11),
            _hoisted_12
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _withDirectives(_createElementVNode("textarea", {
            name: "",
            id: "",
            cols: "30",
            rows: "10",
            placeholder: "Ex: As informações para a folha precisam ser enviadas até o dia 20 de cada mês.",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payload.value.description) = $event))
          }, null, 512), [
            [_vModelText, payload.value.description]
          ])
        ]),
        _createElementVNode("section", null, [
          _hoisted_16,
          _createElementVNode("label", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "stats",
              id: "stats",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.status) = $event))
            }, null, 512), [
              [_vModelCheckbox, payload.value.status]
            ]),
            _hoisted_18
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingAlert.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                onClick: updateAlert,
                disabled: !payload.value.title || !payload.value.limit_date || !payload.value.description
              }, null, 8, _hoisted_19))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.go(-1)))
          })
        ]),
        _createVNode(MyModal, {
          width: '341px !important',
          height: '517px !important',
          className: 'date-limit',
          isOpen: isLimitDateModalOpen.value,
          toggleModal: (v) => isLimitDateModalOpen.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createVNode(MyDatePicker, {
              min: { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() },
              name: 'limit',
              setValue: (date) => selectedLimitDate.value = date,
              format: 'yyyy-mm-dd'
            }, null, 8, ["min", "setValue"]),
            _createElementVNode("input", {
              type: "button",
              value: "Aplicar data",
              onClick: _cache[6] || (_cache[6] = ($event: any) => {payload.value.limit_date = selectedLimitDate.value; isLimitDateModalOpen.value = false})
            })
          ]),
          _: 1
        }, 8, ["isOpen", "toggleModal"])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})